import toast from 'react-hot-toast'
import InfoIcon from '@mui/icons-material/Info'
import { NotificationToast } from '../components/notification/NotificationToast.jsx'

export const toastHelper = (messageOrNotification, type) => {
	if (type !== 'notification') toast.dismiss()

	switch (type) {
		case 'error':
			return toast.error(typeof messageOrNotification === 'string' ? messageOrNotification : messageOrNotification?.message)
		case 'success':
			return toast.success(typeof messageOrNotification === 'string' ? messageOrNotification : messageOrNotification?.message)
		case 'info':
			return toast(typeof messageOrNotification === 'string' ? messageOrNotification : messageOrNotification?.message, {
				icon: <InfoIcon sx={{ color: '#7ca6bd' }} />
			})
		case 'notification': {
			const notification = typeof messageOrNotification === 'object' && messageOrNotification != null
				? messageOrNotification
				: { message: messageOrNotification, type: 'notification' }
			const toastId = notification._id ?? notification.id ?? `notification-${Date.now()}-${Math.random().toString(36).slice(2)}`
			return toast.custom((t) => (
				<NotificationToast
					notification={notification}
					onDismiss={() => toast.dismiss(t.id)}
				/>
			), {
				duration: 5000,
				position: 'bottom-right',
				id: toastId,
			})
		}
		default:
			return toast(typeof messageOrNotification === 'string' ? messageOrNotification : messageOrNotification?.message)
	}
}
